enum Permissions {
  user = 'user',
  admin = 'admin',
  superAdmin = 'superadmin',
  god = 'god',
}
export default Permissions;
